var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 35.3333H17.3337C13.3337 35.3333 10.667 33.3333 10.667 28.6667V19.3333C10.667 14.6667 13.3337 12.6667 17.3337 12.6667H30.667C34.667 12.6667 37.3337 14.6667 37.3337 19.3333V28.6667C37.3337 33.3333 34.667 35.3333 30.667 35.3333Z",
    stroke: "#0052CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 20H12.0003C16.0003 20 17.3337 18.6667 17.3337 14.6667V13.3333M37.3337 20H36.0003C32.0003 20 30.667 18.6667 30.667 14.6667V13.3333M10.667 28H12.0003C16.0003 28 17.3337 29.3333 17.3337 33.3333V34.6667M37.3337 28H36.0003C32.0003 28 30.667 29.3333 30.667 33.3333V34.6667M24.0003 28C25.0612 28 26.0786 27.5786 26.8288 26.8284C27.5789 26.0783 28.0003 25.0609 28.0003 24C28.0003 22.9391 27.5789 21.9217 26.8288 21.1716C26.0786 20.4214 25.0612 20 24.0003 20C22.9395 20 21.922 20.4214 21.1719 21.1716C20.4218 21.9217 20.0003 22.9391 20.0003 24C20.0003 25.0609 20.4218 26.0783 21.1719 26.8284C21.922 27.5786 22.9395 28 24.0003 28Z",
    stroke: "#0052CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.e35d749afe5aae61cf8cf6026c352fbc.svg";
export { ForwardRef as ReactComponent };